/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IEmptyStateActionSchema {
  /** Запрос, который применяет действие. Пуст у changeFilters — там применять нечего **/
  jsonQuery?: object;
  /** Подпись кнопки **/
  title: string;
  /** Вид действия **/
  type: EType;
}

export enum EType {
  /** Изменить фильтры **/
  'ChangeFilters' = 'changeFilters',
  /** Искать в регионе, который сейчас видно на карте **/
  'ChangeRegion' = 'changeRegion',
  /** Снять все показанные теги **/
  'ResetAllTags' = 'resetAllTags',
}
